import React from "react";
import _ from "lodash";
import qs from "query-string";

const withPagination = (Component) => {
  return class extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.location.search !== this.props.location.search) {
        let query = nextProps.location.search;
        this.props.retrievePagination(qs.parse(query));
      }
    }

    refreshList() {
      this.props.retrievePagination(qs.parse(this.props.location.search));
    }

    render() {
      return <Component {...this.props} refreshList={this.refreshList.bind(this)} />;
    }
  };
};

export default withPagination;
